import React, { useCallback, useEffect } from 'react';
import NewsContainer from './NewsDetail/NewsContainer.jsx';
import { useTranslation } from 'react-i18next';
import {
  useGetNewsCategoriesQuery,
  useGetNewsQuery,
} from '../../../../redux/services/news.jsx';
import { useFilterHandlers } from './useFilterHandlers.js';

const NEWS_REFRESH_INTERVAL = 5 * 60 * 1000;

const HomePage = () => {
  const { t, i18n } = useTranslation();
  const isEnglish = i18n.language === 'en';

  useEffect(() => {
    document.title = t('Fakulta riadenia a informatiky');
  }, []); // Runs on mount

  const {
    currentPage,
    //wereFiltersUsed,
    selectedCategories,
    handleCategoriesChange,
    handlePageChange,
  } = useFilterHandlers();

  const { data: newsCategories } = useGetNewsCategoriesQuery();

  const { data, isLoading, isFetching, refetch } = useGetNewsQuery(
    {
      page: currentPage,
      categories: selectedCategories,
      isEnglish,
    },
    {
      pollingInterval: NEWS_REFRESH_INTERVAL,
    },
  );

  const triggerFetchNews = useCallback(() => {
    window.scrollTo(0, 0); // when news page changes it will scroll to top
    refetch();
  }, [currentPage, isEnglish, selectedCategories]);

  return (
    <>
      <NewsContainer
        selectedCategories={selectedCategories}
        categories={newsCategories || []}
        news={data}
        onCategoriesChange={handleCategoriesChange}
        onPageChange={handlePageChange}
        isLoadingNews={isLoading}
        isFetchingNews={isFetching}
        currentPaginatorPage={currentPage}
        onRefetch={triggerFetchNews}
      />
    </>
  );
};

export default HomePage;
